'use strict';
import { BaseService } from '@narrate/base-sdk';

class TransactionService extends BaseService {

  constructor() {
    super({ configPath: 'services.transactions' });
  }

  async list() {
    return await this.requestRootResource();
  }

  async listEarnings() {
    return await this.requestResource('earnings');
  }

  /**
   * TODO: deprecate once frontend uses balance
   * @returns an earnings summary for the current user.
   */
  // async earningsSummary() {
  //   const { Items: transactions } = await this.listEarnings();
  //   return {
  //     total: transactions.map(t => t.recipientReceivedAmount || 0).reduce((total, current) => total + current, 0),
  //   };
  // }

  // async getBalance() {
  //   return await this.requestResource('getBalance');
  // }

  // async listAdjustments() {
  //   return await this.requestResource('listAdjustments');
  // }

  // async listPayouts() {
  //   return await this.requestResource('listPayouts');
  // }

  /**
   * @returns {Object}
   *  @property {Object} Item
   *   @property {Number} earningsTotal
   *   @property {Number} payoutsTotal
   *   @property {Number} balance
   */
  async getAccountSummary() {
    return await this.requestResource('accountSummary');
  }
}

export default TransactionService;
